import Head from "next/head"
import { GlobalDataOptions } from "app/insights/GlobalDataOptions"
import { FC, PropsWithChildren, ReactNode } from "react"
import { ApplicationHeader } from "../components/header/ApplicationHeader"
import { Main } from "../components/layout/Main"
import { ApplicationContextProvider } from "../contexts/ApplicationContext"
import { BillingContextProvider } from "../contexts/BillingContext"
import { useEnsureSession } from "app/authv2/use-session"

import { BackButtonBehavior } from "../components/header/application/ApplicationLoader"
import { CommandBar } from "app/commandbar/CommandBar"
import { cn } from "@superwall/ui/lib/utils"

type DashboardLayoutProps = {
  fullWidth?: boolean
  title?: ReactNode | string
  hasHeader?: boolean
  containerClassName?: string
  wrapperClassName?: string
  navBarTitle?: ReactNode | string
  backButtonBehavior?: BackButtonBehavior
}

const DashboardLayout: FC<PropsWithChildren<DashboardLayoutProps>> = ({
  children,
  fullWidth = false,
  title,
  hasHeader = true,
  containerClassName,
  wrapperClassName,
  backButtonBehavior = "auto",
  navBarTitle,
}) => {
  useEnsureSession()

  return (
    <div className={cn("sm:[zoom:0.9] lg:[zoom:1]", containerClassName)}>
      <Head>
        <title>{title || "Dashboard"}</title>
        <link rel="icon" href="/favicon.ico" />
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no, user-scalable=no, viewport-fit=cover"
        />
      </Head>
      <CommandBar />
      <ApplicationContextProvider>
        <BillingContextProvider>
          <GlobalDataOptions>
            {hasHeader && (
              <ApplicationHeader
                backButtonBehavior={backButtonBehavior}
                title={navBarTitle}
                fullWidth={fullWidth}
              />
            )}

            <Main wrapperClassName={wrapperClassName} fullWidth={fullWidth}>
              {children}
            </Main>
          </GlobalDataOptions>
        </BillingContextProvider>
      </ApplicationContextProvider>
    </div>
  )
}

export default DashboardLayout
